export const toggleSwitchStyles = {
  root: {
    width: '40px',
      height: '24px',
      borderRadius: '75px',
      borderWidth: '0.1rem',
      hoverBorderColor: 'rgba(36, 49, 74, 1)',
      borderColor: 'rgba(36, 49, 74, 1)',
      gap: '0.25rem',
  },
  handle: {
    borderRadius: '50%',
      size: '12px',
  },
  colorScheme: {
    light: {
      root: {
        background: '#fff',
          hoverBackground: '#fff',
          checkedBackground: 'rgba(36, 49, 74, 1)',
          checkedHoverBackground: 'rgba(36, 49, 74, 1)'
      },
      handle: {
        background: 'rgba(36, 49, 74, 1)',
          hoverBackground: 'rgba(36, 49, 74, 1)',
          checkedBackground: '#fff',
          checkedHoverBackground: '#fff',
      }
    },
  }
}